import { StyledButton } from '@components/Button';
import { faFileCsv, faFilePdf, IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonProps } from '@mui/material';
import MUITypography from '@mui/material/Typography';
import type { Order } from '@partful/shared-types';
import { ExportCsvButton } from './ExportCsvButton';
import { ExportPdfButton } from './ExportPdfButton';

export type ExportButtonProps = {
  label?: string;
  icon: IconDefinition;
  onClick?: () => void;
} & Omit<ButtonProps, 'type'> &
  (ExportCsvButtonProps | ExportPdfButtonProps);

type ExportPdfButtonProps = {
  type: 'pdf';
  orderMarkup?: JSX.Element;
  order: Order;
  orders?: never;
};

type ExportCsvButtonProps = {
  type: 'csv';
  order?: never;
  orders: Order[];
  orderMarkup?: never;
};

export function ExportButton(props: Readonly<Omit<ExportButtonProps, 'icon'>>) {
  const { label, type, order, orders, ...buttonProps } = props;

  switch (type) {
    case 'csv':
      return <ExportCsvButton {...buttonProps} icon={faFileCsv} orders={orders!} label={label ?? 'CSV'} />;
    case 'pdf':
    default:
      return <ExportPdfButton {...buttonProps} icon={faFilePdf} order={order!} label={label ?? 'PDF'} />;
  }
}

export function ExportButtonBase(props: Readonly<Omit<ExportButtonProps, 'order'>>) {
  const { type, label, onClick, icon, orderMarkup, ...buttonProps } = props;

  return (
    <StyledButton
      {...buttonProps}
      startIcon={<FontAwesomeIcon icon={icon} />}
      variant="outlined"
      onClick={onClick}
      data-testid={`download-${type}-button`}
    >
      <MUITypography fontWeight="bold">{label ?? /* istanbul ignore next */ 'Export order'}</MUITypography>
      {orderMarkup}
    </StyledButton>
  );
}
